export class Step2 {
    constructor() {}

    intitule = 'stepper.form.mapa_in.step1';
    getobjet = 'form.mapa_in.getobjet';
    gettravaux = 'form.mapa_in.gettravaux';
    getconceptionrealisation = 'form.mapa_in.getconceptionrealisation';
    getexecution = 'form.mapa_in.getexecution';
    getfournitures = 'form.mapa_in.getfournitures';
    getachat = 'form.mapa_in.getachat';
    getcreditbail = 'form.mapa_in.getcreditbail';
    getlocation = 'form.mapa_in.getlocation';
    getlocationvente = 'form.mapa_in.getlocationvente';
    getservices = 'form.mapa_in.getservices';
    getmarcheservices = 'form.mapa_in.getmarcheservices';
    getspan1 = 'form.mapa_in.getspan1';
    getnum = 'form.mapa_in.getnum';
    gettypevoie = 'form.mapa_in.gettypevoie';
    getnomvoie = 'form.mapa_in.getnomvoie';
    getcp = 'form.mapa_in.getcp';
    getville = 'form.mapa_in.getville';
    getspan2 = 'form.mapa_in.getspan2';
    getlieuexecutionlivraison = 'form.mapa_in.getlieuexecutionlivraison';
    getmotclef = 'form.mapa_in.getmotclef_liste_avi_';

}
